var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcoAiSolutions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_3475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62467 10.3334C6.56515 10.1027 6.44489 9.89215 6.27641 9.72367C6.10793 9.55519 5.89738 9.43494 5.66667 9.37542L1.57667 8.32075C1.50689 8.30095 1.44547 8.25892 1.40174 8.20105C1.35801 8.14318 1.33435 8.07262 1.33435 8.00008C1.33435 7.92755 1.35801 7.85699 1.40174 7.79912C1.44547 7.74125 1.50689 7.69922 1.57667 7.67942L5.66667 6.62408C5.8973 6.56462 6.1078 6.44447 6.27627 6.27611C6.44474 6.10775 6.56504 5.89734 6.62467 5.66675L7.67933 1.57675C7.69894 1.5067 7.74092 1.44498 7.79888 1.40101C7.85684 1.35705 7.92759 1.33325 8.00033 1.33325C8.07308 1.33325 8.14383 1.35705 8.20179 1.40101C8.25974 1.44498 8.30173 1.5067 8.32133 1.57675L9.37533 5.66675C9.43485 5.89747 9.55511 6.10802 9.72359 6.2765C9.89207 6.44498 10.1026 6.56523 10.3333 6.62475L14.4233 7.67875C14.4937 7.69815 14.5557 7.74009 14.5999 7.79814C14.6441 7.85618 14.668 7.92713 14.668 8.00008C14.668 8.07304 14.6441 8.14399 14.5999 8.20203C14.5557 8.26008 14.4937 8.30202 14.4233 8.32142L10.3333 9.37542C10.1026 9.43494 9.89207 9.55519 9.72359 9.72367C9.55511 9.89215 9.43485 10.1027 9.37533 10.3334L8.32067 14.4234C8.30106 14.4935 8.25908 14.5552 8.20112 14.5992C8.14316 14.6431 8.07241 14.6669 7.99967 14.6669C7.92692 14.6669 7.85617 14.6431 7.79821 14.5992C7.74026 14.5552 7.69827 14.4935 7.67867 14.4234L6.62467 10.3334Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2V4.66667",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33325H12",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 11.3333V12.6666",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_3475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoAiSolutions);
export default __webpack_public_path__ + "static/media/eco-ai-solutions.6ed65a68f2059451b7532522da28b63f.svg";
export { ForwardRef as ReactComponent };